export { default as useMutationObserver } from './useMutationObserver.js';